const REASONS = [
  {
    icon: 'fa-gem',
    title: 'Born of Cosmic Forces',
    text: 'Gemstones are compressed deep in the earth over millions of years, each carrying the vibration of its ruling planet. Worn on the skin, the stone absorbs light and transfers that planetary energy to the wearer.',
  },
  {
    icon: 'fa-route',
    title: 'The Journey Dulls Them',
    text: 'From mining to cutting, polishing, transit and retail, a gemstone passes through countless hands and environments — absorbing the negativity of its surroundings and losing its natural potency along the way.',
  },
  {
    icon: 'fa-hands-praying',
    title: 'Ritual Restores Potency',
    text: 'A Vedic pooja purifies the stone of every absorbed dosha and re-awakens its dormant power through sacred mantras — so the gem reaches you spiritually alive, attuned and ready to work for you.',
  },
]

export default function WhyEnergizeSection() {
  return (
    <section className="py-20 md:py-24 md:px-12 bg-background">
      <div className="container mx-auto max-w-350 px-6 md:px-10 lg:px-16">
        <div className="max-w-2xl mx-auto text-center space-y-3 mb-14">
          <div className="flex items-center justify-center gap-3">
            <span className="h-px w-8 bg-secondary/50"></span>
            <span className="text-[10px] uppercase tracking-[0.4em] text-secondary font-bold">Why It Matters</span>
            <span className="h-px w-8 bg-secondary/50"></span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl uppercase leading-tight text-primary">
            Why Gemstones Need <span className="text-gradient-gold font-bold block">Energization</span>
          </h2>
          <p className="text-xs md:text-sm leading-relaxed text-gray-500">
            An un-energized gemstone is only an ornament. Purification and prana pratishtha turn it into a living remedy.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {REASONS.map((r) => (
            <div key={r.title} className="group rounded-3xl border border-gray-200 bg-white/80 p-8 shadow-sm backdrop-blur-sm transition-all duration-300 hover:shadow-md hover:border-secondary/30">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/5 text-primary transition-colors duration-300 group-hover:bg-secondary group-hover:text-white">
                <i className={`fa-solid ${r.icon} text-xl`}></i>
              </div>
              <h3 className="mt-6 font-heading text-lg uppercase tracking-wide text-primary font-bold">{r.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-gray-500">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
